import { Box } from "@chakra-ui/layout";
import { Modal } from "antd";
import FormContaBancaria from "../../Input/SelectContaBancaria/FormContaBancaria";

interface ModalContaBancariaProps {
  isOpenModal: boolean;
  onClose: () => any;
  onSuccess: (id: string) => any;
  tenantId?: string;
  defaultValue?: any | null;
}

function ModalContaBancaria({
  isOpenModal,
  onClose,
  onSuccess,
  tenantId,
  defaultValue,
}: ModalContaBancariaProps) {
  return (
    <Modal
      centered
      visible={isOpenModal}
      footer={null}
      onCancel={onClose}
      destroyOnClose
      width="600px"
    >
      <Box>
        {isOpenModal ? (
          <FormContaBancaria
            visible={isOpenModal}
            onClose={onClose}
            onSuccess={onSuccess}
            tenantId={tenantId}
            id={defaultValue?.id}
            defaultValue={defaultValue}
          />
        ) : null}
      </Box>
    </Modal>
  );
}

export default ModalContaBancaria;
